// SECURITY: shared cache policy for every query that holds plaintext PINs. gcTime 0 removes
// them from the cache the moment the consuming view unmounts, and staleTime 0 avoids serving
// them from memory later. retry false keeps a rejected request from being repeated.
export const SENSITIVE_QUERY_OPTIONS = { staleTime: 0, gcTime: 0, retry: false } as const;
